import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'

export const Title = () => {
  return (
    <Element
      elementName="p"
      style={{
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '24px',
        color: '#0553A5',
        textTransform: 'uppercase',
      }}
    >
      <Translate value="score.standard.CORPORATE_SCORING" />
    </Element>
  )
}
